<template>
  <p>
    <label for="sellingprice">{{$store.getters.translations.purchase_price}}</label>
    <input v-bind:value="sellingPrice" @change="changeValue" type="text" id="sellingprice">
  </p>
  <slider v-bind:value="sellingPrice"
          v-bind:min="20000"
          v-bind:max="2000000"
          @slider-change="sliderChangeValue"></slider>
</template>

<script>

import Slider from "./Slider";

export default {
  name: "SellingPrice",
  components: {Slider},
  props:['sellingPrice'],
  emits:['change-selling-price'],
  data(){
    return {
    }
  },
  methods:{
    changeValue(event){
      this.$emit('change-selling-price',event.target.value)
    },
    sliderChangeValue(value){
      this.$emit('change-selling-price',value)
    }

  },
}
</script>

<style scoped>

</style>
